import api from './api';

const AUTH_TOKEN_KEY = 'sunset_admin_token';

export default {
  namespaced: true,
  state: {
    authToken: localStorage.getItem(AUTH_TOKEN_KEY) || '',
  },
  getters: {
    isAuthenticated: state => !!state.authToken,
  },
  mutations: {
    setAuthToken(state, token) {
      state.authToken = token;
      localStorage.setItem(AUTH_TOKEN_KEY, token);
    },
    clearAuthToken(state) {
      state.authToken = '';
      localStorage.removeItem(AUTH_TOKEN_KEY);
    },
  },
  actions: {
    async login({ commit }, { email, password }) {
      try {
        const response = await api.login(email, password);
        if (response && response.token) {
          commit('setAuthToken', response.token);
          return { success: true };
        }
        return { success: false, error: 'Invalid response: No token received' };
      } catch (error) {
        let errorMessage = 'Login failed. Please check your credentials.';
        if (error.response && error.response.data) {
          errorMessage = error.response.data.error || error.response.data.message || errorMessage;
        } else if (error.message) {
          errorMessage = error.message;
        }
        return { success: false, error: errorMessage };
      }
    },

    logout({ commit }) {
      commit('clearAuthToken');
    },

    async callEndpoint({ state }, { endpoint, data }) {
      if (!state.authToken) {
        throw new Error('Not authenticated');
      }
      return await api.callEndpoint(endpoint, data, state.authToken);
    },

    async getUserDataByEmail({ state }, email) {
      if (!state.authToken) {
        throw new Error('Not authenticated');
      }
      return await api.getUserData(email, state.authToken);
    },

    async getUserMigrationData({ state }, userId) {
      if (!state.authToken) {
        throw new Error('Not authenticated');
      }
      return await api.getUserMigrationData(userId, state.authToken);
    },

    async getUsers({ state }) {
      if (!state.authToken) {
        throw new Error('Not authenticated');
      }
      return await api.getUsers(state.authToken);
    },

    async getUserById({ state }, userId) {
      if (!state.authToken) {
        throw new Error('Not authenticated');
      }
      return await api.getUserById(userId, state.authToken);
    },

    async loginAsUser({ state }, { userId }) {
      if (!state.authToken) {
        throw new Error('Not authenticated');
      }
      return await api.loginAsUser(userId, state.authToken);
    },
  },
};